import React from 'react';
import { Box, Button, ButtonMode } from 'edenred-ui';

import { StepsProps } from '@epi-models/components/Steps';

import './Steps.scss';

export const Steps = ({
  pages,
  activePageId,
  navigationClick,
  isStepClickable = () => true
}: StepsProps) => {
  const activePageIndex = activePageId
    ? pages.findIndex(page => page.id === activePageId)
    : 0;

  return (
    <Box className="Steps showgrid">
      <Box display="flex" justifyContent="center" className="row">
        <div className="Content">
          {pages.map((page, index) => (
            <div
              key={page.id}
              className={`col- ${activePageIndex === index ? 'active' : ''} ${
                activePageIndex > index ? 'visited' : ''
              } text-center step-button-container`}
            >
              <span className="step-button">
                <Button
                  mode={ButtonMode.None}
                  id={`navigate-to-step-btn-${index + 1}`}
                  onClick={() => navigationClick(activePageIndex, index)}
                  className={`btn ${
                    isStepClickable(activePageIndex, index)
                      ? ''
                      : 'not-clickable'
                  }`}
                >
                  {index + 1}
                </Button>
              </span>
              <span className="desktop">{page.name}</span>
            </div>
          ))}
        </div>
      </Box>
      <Box display="flex" justifyContent="center" className="mobile row">
        <span>{pages[activePageIndex].name}</span>
      </Box>
    </Box>
  );
};
